/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon29Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        fillRule={"evenodd"}
        d={
          "M10.002 2.3c4.14 0 7.498 3.455 7.498 7.717s-3.357 7.716-7.498 7.716a7.3 7.3 0 0 1-1.887-.246v-4.793a3.14 3.14 0 0 0 1.887.63c1.774 0 3.213-1.481 3.213-3.307 0-1.827-1.439-3.307-3.213-3.307s-3.214 1.483-3.214 3.309l.003 6.972V19.3H2.5v-9.283C2.5 5.755 5.86 2.3 10.002 2.3"
        }
        clipRule={"evenodd"}
      ></path>
    </svg>
  );
}

export default Icon29Icon;
/* prettier-ignore-end */
